<template>
  <div class="login-card" v-if="visible" @click.stop>
    <div class="card-content">
      <button class="login-btn" @click="goToLogin">{{$t('userMenu.login')}}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoginCard",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    goToLogin() {
      this.$router.push("/login");
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.login-card {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 15px;
  z-index: 1000;

  .card-content {
    background: white;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
    min-width: 150px;
    border: 1px solid #f0f0f0;

    .login-btn {
      width: 100%;
      height: 45px;
      background: #113DFF;
      color: white;
      border: none;
      border-radius: 8px;
      font-size: 16px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        background: #4a1a52;
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(96, 35, 105, 0.3);
      }

      &:active {
        background: #3d1542;
        transform: translateY(0);
      }
    }
  }
}

// 添加箭头指向个人图标
.login-card::before {
  content: "";
  position: absolute;
  top: -8px;
  right: 20px;
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid white;
}

.login-card::after {
  content: "";
  position: absolute;
  top: -9px;
  right: 19px;
  width: 0;
  height: 0;
  border-left: 9px solid transparent;
  border-right: 9px solid transparent;
  border-bottom: 9px solid #f0f0f0;
}
</style>
